// Helpers compartilhados de faixa (distribuição) e de série temporal de
// evolução — usados por qualquer escopo (escola, região, rede). Extraídos do
// AdminPainel para permitir reuso no painel do Gestor sem duplicar lógica.

import { faixaKey, FAIXA_META } from "./format";

/** Consolida a contagem de faixas por chave interna e devolve o formato que o
 * DonutChart espera (name/value/color), na ordem canônica acima→média→abaixo. */
export function donutFaixas(faixas) {
  if (!faixas?.length) return [];
  const cont = {};
  for (const f of faixas) {
    const key = faixaKey(f.faixa);
    cont[key] = (cont[key] ?? 0) + f.total;
  }
  const cor = {
    acima: "var(--color-good)",
    media: "var(--color-warn)",
    abaixo: "var(--color-bad)",
    sem_referencia: "var(--color-surface-3)"
  };
  return ["acima", "media", "abaixo", "sem_referencia"]
    .filter(key => cont[key])
    .map(key => ({
      name: FAIXA_META[key].label,
      value: cont[key],
      color: cor[key]
    }));
}

/** Preenche meses faltantes entre o primeiro e o último ponto com nulls, pra o
 * eixo temporal ficar contínuo (com connectNulls, as linhas atravessam os gaps). */
export function preencherMeses(pts) {
  if (pts.length < 2) return pts;
  const byMes = new Map(pts.map(p => [p.mes, p]));
  const [y0, m0] = pts[0].mes.split("-").map(Number);
  const [y1, m1] = pts[pts.length - 1].mes.split("-").map(Number);
  const out = [];
  let y = y0;
  let m = m0;
  while (y < y1 || (y === y1 && m <= m1)) {
    const key = `${y}-${String(m).padStart(2, "0")}`;
    out.push(
      byMes.get(key) ?? {
        mes: key,
        nota_media: null,
        engajamento: null,
        conclusao: null
      }
    );
    m += 1;
    if (m > 12) {
      m = 1;
      y += 1;
    }
  }
  return out;
}
